import React, { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots, faXmark, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import "./SideButtonDrag.scss";

import { firebase, firestore } from "../../utils/firebase";
import { useCollectionData } from "react-firebase-hooks/firestore";

import avatar1 from "../../assets/images/avatar/avatar1.webp";
import avatar2 from "../../assets/images/avatar/avatar2.webp";
import avatar3 from "../../assets/images/avatar/avatar3.webp";
import avatar4 from "../../assets/images/avatar/avatar4.webp";
import avatar5 from "../../assets/images/avatar/avatar5.webp";
import avatar6 from "../../assets/images/avatar/avatar6.webp";
import avatar7 from "../../assets/images/avatar/avatar7.webp";
import avatar8 from "../../assets/images/avatar/avatar8.webp";
import avatar9 from "../../assets/images/avatar/avatar9.webp";
import avatar10 from "../../assets/images/avatar/avatar10.webp";
import avatar11 from "../../assets/images/avatar/avatar11.webp";
import avatar12 from "../../assets/images/avatar/avatar12.webp";
import avatar13 from "../../assets/images/avatar/avatar13.webp";
import avatar14 from "../../assets/images/avatar/avatar14.webp";
import avatar15 from "../../assets/images/avatar/avatar15.webp";
import avatar16 from "../../assets/images/avatar/avatar16.webp";
import avatar17 from "../../assets/images/avatar/avatar17.webp";
import avatar18 from "../../assets/images/avatar/avatar18.webp";
import avatar19 from "../../assets/images/avatar/avatar19.webp";
import avatar20 from "../../assets/images/avatar/avatar20.webp";
import avatar21 from "../../assets/images/avatar/avatar21.webp";
import avatar22 from "../../assets/images/avatar/avatar22.webp";
import avatar23 from "../../assets/images/avatar/avatar23.webp";
import avatar24 from "../../assets/images/avatar/avatar24.webp";

const avatars = [avatar1, avatar2, avatar3, avatar4, avatar5, avatar6, avatar7, avatar8, avatar9, avatar10, avatar11, avatar12, avatar13, avatar14, avatar15, avatar16, avatar17, avatar18, avatar19, avatar20, avatar21, avatar22, avatar23, avatar24];

const getAvatar = (author) => {
  const authorName = author?.nickname || author || "Anon";
  const index = authorName.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return avatars[index % 24];
};

function formatTimestamp(timestamp) {
  const date = timestamp?.toDate();
  if (!date) return "";
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  return `${hours}:${minutes}`;
}

// firestore imported from utils/firebase

function MiniChat({ nickname, onClose }) {
  const dummy = useRef();
  const messagesRef = firestore.collection("messages");
  const query = messagesRef.orderBy("createdAt", "desc").limit(20);
  const [messages] = useCollectionData(query, { idField: "id" });
  const [formValue, setFormValue] = useState("");

  const sendMessage = async (e) => {
    e.preventDefault();
    if (!formValue.trim()) return;
    await messagesRef.add({
      text: formValue,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      author: nickname,
    });
    setFormValue("");
    dummy?.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    dummy?.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="mini-chat">
      <div className="mini-chat__header">
        <span>Chat</span>
      </div>
      <div className="mini-chat__messages">
        {messages &&
          messages
            .slice(0)
            .reverse()
            .map((msg, index) => (
              <div key={index} className="mini-chat__msg">
                <img src={getAvatar(msg.author)} alt="" className="mini-chat__avatar" />
                <div className="mini-chat__body">
                  <div className="mini-chat__meta">
                    <span className="mini-chat__author">
                      {msg.author?.nickname || msg.author || "Anon"}
                    </span>
                    <span className="mini-chat__time">
                      {formatTimestamp(msg.createdAt)}
                    </span>
                  </div>
                  <p className="mini-chat__text">{msg.text}</p>
                </div>
              </div>
            ))}
        <span ref={dummy}></span>
      </div>
      <form className="mini-chat__form" onSubmit={sendMessage}>
        <input
          value={formValue}
          onChange={(e) => setFormValue(e.target.value)}
          placeholder={
            nickname
              ? "Acendendo o lampião do saloon..."
              : "Faça login para enviar"
          }
          className="mini-chat__input"
          disabled={!nickname}
        />
        <button
          type="submit"
          disabled={!formValue.trim() || !nickname}
          className="mini-chat__send"
          aria-label="Enviar"
        >
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </form>
    </div>
  );
}

const SideButtonDrag = () => {
  const [isChatVisible, setIsChatVisible] = useState(true);
  const nickname = useSelector((state) => state?.session?.nickname);

  return (
    <div className="side-chat">
      <button className="side-chat__toggle" onClick={() => setIsChatVisible(!isChatVisible)}>
        <FontAwesomeIcon icon={isChatVisible ? faXmark : faCommentDots} />
      </button>

      {isChatVisible && (
        <div className="side-chat__panel">
          <MiniChat nickname={nickname} />
        </div>
      )}
    </div>
  );
};

export default SideButtonDrag;
